'use strict'

import Auth from "./Auth";

class Brands{
  
    static getBrands(params = null){ 
        var queryString = Object.keys(params)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');

        return Auth.makePrivateGet(`${BASE_URL}api/brands?${queryString}`);
    }

    static getBrandById(id, fields){
        let query = '';
        
        if(fields != null){
            query += `fields=${fields.join(',')}&`;
        }

        //Remuevo último caracter si es &
        if(query.slice(-1) == '&'){
            query = query.slice(0,-1);
        }

        return Auth.makePrivateGet(`${BASE_URL}api/brands/${id}?${query}`);
    }

    static requestCreate(params = null)
    {
        return Auth.makePrivatePost(`${BASE_URL}api/brands/request-create`, params);
    }

    static createClient(params = null)
    {
        return Auth.makePrivatePost(`${BASE_URL}api/brands`, params);
    }

    static updateClient(id, params = null)
    {
        return Auth.makePrivatePut(`${BASE_URL}api/brands/${id}`, params);
    }

    static deleteClient(id)
    {
        return Auth.makePrivateDelete(`${BASE_URL}api/brands/${id}`);
    }    
}

export default Brands;
